import React from 'react';
import { displayValue } from '../utils/changedFields';
import './SaveConflictDialog.css';

// Shown when a Save is refused because someone else changed the same fields after this person
// opened the job or work order. conflicts: [{ label, theirs, yours }] (display text).
const SaveConflictDialog = ({ what, conflicts, saving, onSaveMine, onKeepTheirs }) => (
  <div className="unsaved-changes-modal">
    <div className="unsaved-changes-content save-conflict-content">
      <h3>Changed by someone else</h3>
      <p>
        While you had this {what} open, someone else changed {conflicts.length === 1 ? 'this' : 'these'}.
        Nothing was saved yet.
      </p>
      <ul className="save-conflict-list">
        {conflicts.map(({ label, theirs, yours }) => (
          <li key={label}>
            <strong>{label}</strong>
            <div><span className="save-conflict-who">Theirs:</span> {theirs}</div>
            <div><span className="save-conflict-who">Yours:</span> {yours}</div>
          </li>
        ))}
      </ul>
      <p className="save-conflict-help">
        <b>Keep theirs</b> shows their changes, keeps your other edits, and waits for you to Save.
        <br />
        <b>Save mine</b> saves your changes over theirs.
      </p>
      <div className="unsaved-changes-buttons">
        <button type="button" onClick={onSaveMine} disabled={saving}>{saving ? 'Saving...' : 'Save mine'}</button>
        <button type="button" onClick={onKeepTheirs} disabled={saving}>Keep theirs</button>
      </div>
    </div>
  </div>
);

// [{ label, theirs, yours }] for the dialog. picture shows as photo text, not a URL.
export const describeConflicts = (fields, labels, current, mine) =>
  fields.map((field) => {
    if (field === 'picture') {
      return { label: labels.picture || 'Main photo', theirs: current.picture ? 'A photo they added' : 'No photo', yours: 'The photo you picked' };
    }
    return { label: labels[field] || field, theirs: displayValue(current[field]), yours: displayValue(mine[field]) };
  });

export default SaveConflictDialog;
